import { Usuario } from '../auth/auth.models';

/** Nombre a mostrar del usuario (cae al username si no hay nombre completo). */
export function nombreUsuario(usuario: Usuario | null): string {
  return usuario?.nombre?.trim() || usuario?.username || 'Usuario';
}

/** Subtítulo del usuario en el chrome: su cargo en SIGERH, o la fuente del SSO. */
export function rolUsuario(usuario: Usuario | null): string {
  return usuario?.detalles?.cargo || 'SIGERH';
}

/** Iniciales (una o dos letras) para el avatar. */
export function iniciales(usuario: Usuario | null): string {
  const base = nombreUsuario(usuario);
  const partes = base.split(/\s+/).filter(Boolean);
  const letras = partes.length >= 2 ? partes[0][0] + partes[1][0] : base.slice(0, 2);
  return letras.toUpperCase();
}
